exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image[data-v-4774165b] {\r\n  float: left;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center center;\r\n  border: 1px solid #ebebeb;\r\n  margin: 5px;\n}\r\n", ""]);

// exports
